// Mirror of backend enum `DocumentType` (si.medifit.sharedk.DocumentType)
export enum DocumentType {
    MEDICAL_CERTIFICATE = 'MEDICAL_CERTIFICATE',
    MEDICAL_CERTIFICATE_DRIVER = 'MEDICAL_CERTIFICATE_DRIVER',
    MEDICAL_CERTIFICATE_DRIVER_SPECIAL = 'MEDICAL_CERTIFICATE_DRIVER_SPECIAL',
    MEDICAL_CERTIFICATE_WEAPON = 'MEDICAL_CERTIFICATE_WEAPON',
    MEDICAL_REPORT = 'MEDICAL_REPORT',
    OTHER = 'OTHER',
    STRUCTURED = 'STRUCTURED',
    REFERRAL = 'REFERRAL',
    STRUCTURED_REFERRAL = 'STRUCTURED_REFERRAL',
    INVOICE = 'INVOICE',
    CUSTOMER_DOCUMENT = 'CUSTOMER_DOCUMENT',
}
